module.exports = __webpack_public_path__ + "img/inwoneraantal.aac677fb.svg";